"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-carbon
 * (C) Copyright IBM Corp. 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const react_1 = tslib_1.__importStar(require("react"));
const carbon_components_react_1 = require("carbon-components-react");
const StringResource_1 = require("../nls/StringResource");
const settings_1 = tslib_1.__importDefault(require("../settings"));
const { prefix } = settings_1.default;
const ARIALABEL = StringResource_1.stringResource.get('codeSnippetCopyText');
const CLASS = `${prefix}-code-snippet-component`;
const COPYBUTTONDESCRIPTION = StringResource_1.stringResource.get('codeSnippetCopy');
const COPYLABEL = StringResource_1.stringResource.get('codeSnippetCopyText');
const FEEDBACK = StringResource_1.stringResource.get('codeSnippetCopied');
const SHOWLESSTEXT = StringResource_1.stringResource.get('codeSnippetShowLess');
const SHOWMORETEXT = StringResource_1.stringResource.get('codeSnippetShowMore');
class CodeSnippet extends react_1.Component {
    constructor() {
        super(...arguments);
        this.localCopyToClipboard = () => {
            const textArea = this._input;
            const isiOSDevice = navigator.userAgent.match(/ipad|iphone/i);
            if (isiOSDevice) {
                const editable = textArea.contentEditable;
                const { readOnly } = textArea;
                textArea.contentEditable = 'true';
                textArea.readOnly = false;
                const range = document.createRange();
                range.selectNodeContents(textArea);
                const selection = window.getSelection();
                selection.removeAllRanges();
                selection.addRange(range);
                textArea.setSelectionRange(0, 999999);
                textArea.contentEditable = editable;
                textArea.readOnly = readOnly;
            }
            else {
                textArea.select();
            }
            document.execCommand && document.execCommand('Copy');
        };
        this.localOnClick = (event, invokeCopyToClipboard) => {
            var _a, _b;
            invokeCopyToClipboard && this.localCopyToClipboard();
            (_b = (_a = this.props).onClick) === null || _b === void 0 ? void 0 : _b.call(_a, event);
        };
    }
    render() {
        const _a = this.props, { 
        // remove - remapped
        ariaLabel, className, copyButtonDescription, copyLabel, 'data-tid': dataTid, feedback, onClick, showLessText, showMoreText, 
        // remove - local props
        copyToClipboard } = _a, 
        // pass all other props to Carbon CodeSnippet
        otherCodeSnippetProps = tslib_1.__rest(_a, ["ariaLabel", "className", "copyButtonDescription", "copyLabel", 'data-tid', "feedback", "onClick", "showLessText", "showMoreText", "copyToClipboard"]);
        const { wrapText } = this.props;
        // Carbon issue https://github.com/carbon-design-system/carbon/issues/4448#issuecomment-729123543
        // Carbon is to supply default copyToClipboard functionality so client do not have to.
        // Carbon is to supply an optional prop to trigger copyToClipboard  functionality.
        const invokeCopyToClipboard = (copyToClipboard !== null && copyToClipboard !== void 0 ? copyToClipboard : !onClick);
        const mappedAriaLable = (ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : ARIALABEL);
        const mappedClassName = className || wrapText
            ? `${(className !== null && className !== void 0 ? className : '')} ${wrapText ? `${CLASS}-wrap` : ''}`
            : undefined;
        const mappedCopyButtonDescription = (copyButtonDescription !== null && copyButtonDescription !== void 0 ? copyButtonDescription : COPYBUTTONDESCRIPTION);
        const mappedCopyLabel = (copyLabel !== null && copyLabel !== void 0 ? copyLabel : COPYLABEL);
        const mappedDataTid = (dataTid !== null && dataTid !== void 0 ? dataTid : CLASS);
        const mappedFeedback = (feedback !== null && feedback !== void 0 ? feedback : FEEDBACK);
        const mappedOnClick = event => this.localOnClick(event, invokeCopyToClipboard);
        const mappedShowLessText = (showLessText !== null && showLessText !== void 0 ? showLessText : SHOWLESSTEXT);
        const mappedShowMoreText = (showMoreText !== null && showMoreText !== void 0 ? showMoreText : SHOWMORETEXT);
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(carbon_components_react_1.CodeSnippet, Object.assign({ ariaLabel: mappedAriaLable, className: mappedClassName, copyButtonDescription: mappedCopyButtonDescription, copyLabel: mappedCopyLabel, "data-tid": mappedDataTid, feedback: mappedFeedback, onClick: mappedOnClick, showLessText: mappedShowLessText, showMoreText: mappedShowMoreText }, otherCodeSnippetProps)),
            invokeCopyToClipboard && (react_1.default.createElement("textarea", { style: {
                    position: 'absolute',
                    top: 0,
                    opacity: 0,
                    zIndex: -1,
                }, ref: r => (this._input = r), readOnly: true, tabIndex: -1, value: this.props.children }))));
    }
}
exports.default = CodeSnippet;
CodeSnippet.propTypes = Object.assign({}, carbon_components_react_1.CodeSnippet.propTypes);
// Need to remove Carbon default strings to determine if they have been passed in.
// Carbon should not hard code strings that need to be translated.
CodeSnippet.getCarbonDefaultProps = () => {
    const _a = carbon_components_react_1.CodeSnippet.defaultProps, { showLessText, // eslint-disable-line @typescript-eslint/no-unused-vars
    showMoreText } = _a, // eslint-disable-line @typescript-eslint/no-unused-vars
    carbonDefaultProps = tslib_1.__rest(_a, ["showLessText", "showMoreText"]);
    return carbonDefaultProps;
};
CodeSnippet.defaultProps = Object.assign({}, CodeSnippet.getCarbonDefaultProps());
